import React, { useEffect, useState } from 'react';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import { propTypes, getUserSubscriptionLevel } from '../../util/types';
import config from '../../config';
import {
  Page,
  SectionHero,
  SectionHowItWorks,
  SectionLocations,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  NamedRedirect
} from '../../components';
import { TopbarContainer } from '../../containers';

import facebookImage from '../../assets/semotoFacebook-1200x630.jpg';
import twitterImage from '../../assets/semotoTwitter-600x314.jpg';
import css from './LandingPage.module.css';
import LatestListingsSection from '../../components/LatestListingsSection/LatestListingsSection';
import LatestOffersSection from '../../components/LatestOffersSection/LatestOffersSection';
import LatestNewsSection from '../../components/LatestNewsSection/LatestNewsSection';
import LatestEventsSection from '../../components/LatestEventsSection/LatestEventsSection';
export const LandingPageComponent = props => {
  const {
    history,
    intl,
    location,
    scrollingDisabled,
    currentUser,
    currentUserListing,
    currentUserListingFetched,
    onManageDisableScrolling,
    isAuthenticated
  } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'LandingPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

  const hasSubscription = !!getUserSubscriptionLevel(currentUser);

  if (!!currentUser && !hasSubscription) {
    return <NamedRedirect name="SubscriptionPage" />;
  }

  const [providerType, setProviderType] = useState('establishedCompany')

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[{ url: `${config.canonicalRootURL}${twitterImage}`, width: 600, height: 314 }]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer providerType={providerType} />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroContainer}>
            <SectionHero
              className={css.hero}
              history={history}
              location={location}
              currentUser={currentUser}
              intl={intl}
              providerType={providerType}
            />
          </div>
          <ul className={css.sections}>
            <li className={css.section}>
              <div className={css.sectionContentFirstChild}>
                <LatestListingsSection
                  currentUser={currentUser}
                  setProviderType={setProviderType}
                  isAuthenticated={isAuthenticated}
                />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContentFirstChild}>
                <LatestOffersSection authRequired currentUser={currentUser} />
              </div>
            </li>

            <li className={css.section}>
              <div className={css.sectionContentFirstChild}>
                <LatestNewsSection onManageDisableScrolling={onManageDisableScrolling} />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContentFirstChild}>
                <LatestEventsSection onManageDisableScrolling={onManageDisableScrolling} />
              </div>
            </li>
            {/* <li className={css.section}>
              <div className={css.sectionContentFirstChild}>
                <SectionLocations />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionHowItWorks
                  currentUserListing={currentUserListing}
                  currentUserListingFetched={currentUserListingFetched}
                />
              </div>
            </li> */}
          </ul>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

LandingPageComponent.defaultProps = {
  currentUserListing: null,
  currentUserListingFetched: false,
};

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser, currentUserListing, currentUserListingFetched } = state.user;
  const { isAuthenticated } = state.Auth;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUserListing,
    currentUserListingFetched,
    currentUser,
    isAuthenticated
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(LandingPageComponent);

export default LandingPage;
